module.exports = __webpack_public_path__ + "img/lion.610f9843.svg";